import gql from 'graphql-tag'

import { pageInfoData } from './common'

export const articlesByEntityResults = gql`
	fragment articlesByEntityResults on Article {
		id
		user {
			id
			email
			profileCollection {
				edges {
					node {
						id
						firstName
						lastName
					}
				}
			}
		}
		title
		body
		slug
		description
		isPost
		featuredVideo
		image {
			id
			filename
		}
	}
`

export const standardArticleResult = gql`
	fragment standardArticleResult on Article {
		id
		worksAt
		user {
			id
			uid
			email
			god
			profileCollection {
				edges {
					node {
						id
						firstName
						lastName
						cvFilePath
						cvFileOriginalName
						hasAvatar
						avatarContentType
						avatarPath
						experienceCollection {
							edges {
								node {
									position
									company
								}
							}
						}
					}
				}
			}
		}
		readDuration
		title
		body
		slug
		description
		isPost
		postAs

		company {
			id
			name
			slug
			hasLogo
			logoPath
			industry {
				id
				key
			}
		}
		postingCompany
		activeArticleTagCollection {
			edges {
				node {
					id
					votes
					articleTag {
						title
					}
					_ActiveArticleTagToUserCollection {
						edges {
							node {
								user {
									profileCollection {
										edges {
											node {
												firstName
												lastName
												user {
													id
													uid
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
		createdAt
		updatedAt
		featuredVideo
		image {
			id
			filename
		}
	}
`
//eslint-disable-next-line
{
	/* 
	export const standardArticleResult = gql`
	fragment standardArticleResult on Article {
		id
		author {
			id
			uid
			email
			profile {
				id
				firstName
				lastName
				cvFilePath
				cvFileOriginalName
				worksAt {
					id
					company
					position
				}
				hasAvatar
				avatarContentType
				avatarPath
			}
		}
		worksAt {
			id
			company
			position
		}
		readDuration
		title
		body
		slug
		description
		isPost
		postAs
		postingCompany {
			id
			name
			slug
			hasLogo
			logoPath
			industry {
				id
				key
			}
		}
		createdAt
		tags {
			id
			uniqueIdentifier
			title
			votes
			canVote
			voters {
				id
				firstName
				lastName
				user {
					id
					uid
				}
			}
		}
		updatedAt
		featuredVideo
		featuredImage {
			id
			filename
		}
	}
`
	*/
}

export const articleConnectionData = gql`
	fragment articleConnectionData on ArticleConnection {
		edges {
			node {
				...standardArticleResult
			}
			cursor
		}
		pageInfo {
			...pageInfoData
		}
	}
	${standardArticleResult}
	${pageInfoData}
`
